import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Select } from 'antd';
import { TOrganizationResponse, useLazyGetAdsOrganizationsQuery } from 'app/services/edpApiV1/moderator';
import style from './index.module.scss';

type TProps = {
  children?: ReactNode;
  organizationId?: string;
  onOrganizationIdChange: (data: string) => void;
};

const DivisionSearchSettings: FC<TProps> = ({ organizationId, onOrganizationIdChange }) => {
  const [getOrganizations, { data: organizations, isLoading, isFetching }] = useLazyGetAdsOrganizationsQuery();
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [summedOrganizations, setSummedOrganizations] = useState<TOrganizationResponse[]>([]);

  useEffect(() => {
    const firstId = organizations?.data[0]?.id;
    const ifHasOrg = summedOrganizations.find(elem => elem?.id === firstId);

    if (!ifHasOrg && organizations) {
      setSummedOrganizations([...organizations?.data, ...summedOrganizations]);
    }
  }, [organizations]);

  useEffect(() => {
    getOrganizations({ search: '', page, size });
  }, [page, size, getOrganizations]);

  const setOrganization = (value: string) => {
    onOrganizationIdChange(value);
  };

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const { target } = e;

    if (target instanceof HTMLDivElement) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        // пока общее колличество сотрудников не привышает того, что находится в стейте делаю запросы
        const paginationData = organizations?.pagination;
        if (paginationData && paginationData.total >= size * page) {
          setPage(prev => prev + 1);
        }
      }
    }
  };

  const handleFocus = async (e: React.FocusEvent<HTMLElement, Element>) => {
    const { target } = e;
    const paginationData = organizations?.pagination;
    let currentPage = page;
    while (
      target.clientHeight === target.scrollHeight &&
      paginationData &&
      paginationData.total >= size * currentPage
    ) {
      await getOrganizations({ search: '', page: currentPage, size }).unwrap();
      currentPage++;
    }
    setPage(currentPage);
  };

  return (
    <div className={style.actions}>
      <div className={style['actions-top']}>
        <div className={style.organization}>
          <Select
            style={{ width: '100%' }}
            allowClear
            value={organizationId}
            placeholder="Выберите организацию"
            onChange={setOrganization}
            loading={isLoading || isFetching}
            options={summedOrganizations ? summedOrganizations.map(org => ({ value: org.id, label: org.name })) : []}
            onPopupScroll={handlePopupScroll}
            onFocus={handleFocus}
          />
        </div>
      </div>
    </div>
  );
};

export default DivisionSearchSettings;
